export default class CreateDefaultWorkTypePricingError extends Error {

}
